import type { AudienceMagicLink } from "@/types/audience-list-members.types";
import type { MagicLink } from "@/types/working-model";
import { isObject } from "underscore";

const PASSCODE_LIST_EVENT_UUID_SEPARATOR = '___';
export const getDisplayName = (name: string | undefined, defaultDisplay?: string) => {
	if (!name) return defaultDisplay || '';
	const index = name.indexOf(PASSCODE_LIST_EVENT_UUID_SEPARATOR);
	return index === -1 ? name : name.slice(0, index);
};

export const isAudienceMagicLinkArray = (arr: unknown[]): arr is AudienceMagicLink[] => {
	if (!arr.length) return false;
	const firstItem = arr[0];
	return isObject(firstItem) && 'bl_profile' in firstItem && 'code' in firstItem;
};

export const isPasscodeMagicLinkArray = (arr: unknown[]): arr is MagicLink[] => {
	if (!arr.length) return false;
	const firstItem = arr[0];
	return isObject(firstItem) && 'passcode_list_member' in firstItem && 'code' in firstItem;
};